import { Component, OnInit } from '@angular/core';

import { UtilService } from "../../../../shared/services/util.service";
import { ObrigacaoTipoApiService } from "../shared/obrigacao-tipo-api.service";
import { ObrigacaoTipoNavigationService } from "../shared/obrigacao-tipo-navigation.service";
import { Obrigacoeservice } from "../../shared/obrigacao.service";
import { TipoObrigacao } from "../shared/obrigacao-tipo.model";
import { obrigacaoTiposModuleName } from "../shared/data.service";
import {obrigacoesModuleName} from "../../shared/data.service";
import {configuracaoModuleName} from "../../../../shared/services/data.service";
import {DespachoService} from "../../../shared/despacho.service";

@Component({
    template: require('./obrigacao-tipo-list.component.html'),
    styles: [require('./obrigacao-tipo-list.component.css')]
})
export class ObrigacaoTipoListComponent implements OnInit {
    list: any[] = [];
    loading: boolean = true;
    showDisabled: boolean = false;
    obrigacaoTiposModuleName: any = obrigacaoTiposModuleName;
    configuracaoModule: any = configuracaoModuleName;
    module: any = obrigacoesModuleName;

    constructor(
        private _obrigacaoTipoApiService: ObrigacaoTipoApiService,
        private _obrigacaoTipoNavigationService: ObrigacaoTipoNavigationService,
        private _obrigacoeservice: Obrigacoeservice,
        private _utilService: UtilService,
        private _despachoService: DespachoService
    ) { }

    ngOnInit() {
        this.getAll();
    }

    clickNew() {
        this._obrigacoeservice.clearSessionStorage();
        this._obrigacaoTipoNavigationService.goToNew();
    }

    clickEdit(item: TipoObrigacao) {
        this._obrigacoeservice.clearSessionStorage();
        this._obrigacaoTipoNavigationService.goToEdit(item.id);
    }

    clickDelete(item: TipoObrigacao) {
        var onDelete = (function() {
            this.onDelete(item);
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete);
    }

    clickGoToConfig() {
        this._despachoService.goToSettingObrigacoes();
    }

    private getAll() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.list = Response;
            }
            this.loading = false;
        }.bind(this));

        this._obrigacaoTipoApiService.onGetAll(onDone);
    }

    private onDelete(item: any) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                var x: number, lenX: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].id === item.id) {
                        this.list[x].ativo = false;
                        break;
                    }
                }
                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageDeleteError();
            }
        }.bind(this));

        this._obrigacaoTipoApiService.onDelete(item.id, onDone);
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/obrigacoes/obrigacao-tipos/obrigacao-tipo-list/obrigacao-tipo-list.component.ts
 **/